export default ['JsonRPCService', (JsonRPCService) => {
    return {
        getOrCreateAccount: (account) => {
            return JsonRPCService.send('pc', 'gateway/account', 'getOrCreateAccount', [account]);
        },
        getAccountDetails: (accountNumber) => {
            return JsonRPCService.send('pc', 'gateway/account', 'getAccountDetails', [accountNumber]);
        },
        updateAccountDetails: (account) => {
            return JsonRPCService.send('pc', 'gateway/account', 'updateAccountDetails', [account]);
        },
        getNotesForAccount: (accountNumber) => {
            return JsonRPCService.send('pc', 'gateway/account', 'getNotesForAccount', [accountNumber]);
        },
        createNoteForAccount: (accountNumber, noteDTO) => {
            return JsonRPCService.send('pc', 'gateway/account', 'createNoteForAccount', [accountNumber, noteDTO]);
        },
        getDocumentsForAccount: (accountNumber) => {
            return JsonRPCService.send('pc', 'gateway/account', 'getDocumentsForAccount', [accountNumber]);
        },
        getAvailableProductsForAccount: (newSubmission) => {
            return JsonRPCService.send('pc', 'gateway/account', 'getAvailableProductsForAccount', [newSubmission]);
        },
        getPotentialExistingAccounts: (accountSearchCritera) => {
            return JsonRPCService.send('pc', 'gateway/account', 'getPotentialExistingAccounts', [accountSearchCritera]);
        },
        getPolicyTransactionsForAccount: (accountNumber) => {
            return JsonRPCService.send('pc', 'gateway/account', 'getPolicyTransactionsForAccount', [accountNumber]);
        },
        getOpenPolicyTransactionsForAccount: (accountNumber) => {
            return JsonRPCService.send('pc', 'gateway/account', 'getOpenPolicyTransactionsForAccount', [accountNumber]);
        },
        getOwnedBilledPoliciesForAccount: (accountNumber) => {
            return JsonRPCService.send('pc', 'gateway/account', 'getOwnedBilledPoliciesForAccount', [accountNumber]);
        },
        getUnownedBilledPoliciesForAccount: (accountNumber) => {
            return JsonRPCService.send('pc', 'gateway/account', 'getUnownedBilledPoliciesForAccount', [accountNumber]);
        },
        getAccountBillingInvoices: (accountNumber) => {
            return JsonRPCService.send('pc', 'gateway/account', 'getInvoicesForAccount', [accountNumber]);
        },
        getAccountClaims: (accountNumber) => {
            return JsonRPCService.send('pc', 'gateway/account', 'getAccountClaims', [accountNumber]);
        },
        getAccountsForCurrentUser: (createdInLastXDays, queryOptions, queryParameters) => {
            return JsonRPCService.send('pc', 'gateway/account', 'getAccountsForCurrentUser', [createdInLastXDays, queryOptions, queryParameters]);
        },
        getPersonalAccountsForCurrentUser: (createdInLastXDays, queryOptions, queryParameters) => {
            return JsonRPCService.send('pc', 'gateway/account', 'getPersonalAccountsForCurrentUser', [createdInLastXDays, queryOptions, queryParameters]);
        },
        getCommercialAccountsForCurrentUser: (createdInLastXDays, queryOptions, queryParameters) => {
            return JsonRPCService.send('pc', 'gateway/account', 'getCommercialAccountsForCurrentUser', [createdInLastXDays, queryOptions, queryParameters]);
        },
        getAccountsForProducerCode: (createdInLastXDays, queryOptions, producerCode) => {
            return JsonRPCService.send('pc', 'gateway/account', 'getAccountsForProducerCode', [createdInLastXDays, queryOptions, producerCode]);
        },
        getPersonalAccountsForProducerCode: (createdInLastXDays, queryOptions, producerCode) => {
            return JsonRPCService.send('pc', 'gateway/account', 'getPersonalAccountsForProducerCode', [createdInLastXDays, queryOptions, producerCode]);
        },
        getCommercialAccountsForProducerCode: (createdInLastXDays, queryOptions, producerCode) => {
            return JsonRPCService.send('pc', 'gateway/account', 'getCommercialAccountsForProducerCode', [createdInLastXDays, queryOptions, producerCode]);
        },
        getRecentlyViewedAccounts: () => {
            return JsonRPCService.send('pc', 'gateway/account', 'getRecentlyViewedAccounts', []);
        },
        addRecentlyViewedAccounts: (accountNumber) => {
            return JsonRPCService.send('pc', 'gateway/account', 'addRecentlyViewedAccounts', [accountNumber]);
        },
        getAccountJobsForCurrentUser: (createdInLastXDays) => {
            return JsonRPCService.send('pc', 'gateway/account', 'getAccountJobsForCurrentUser', [createdInLastXDays]);
        },
        getAccountBillingData: (accountNumber) => {
            return JsonRPCService.send('pc', 'gateway/account', 'getAccountBillingData', [accountNumber]);
        },
        getAccountJobsSummariesForCurrentUser: (createdInLastXDays) => {
            return JsonRPCService.send('pc', 'gateway/account', 'getAccountJobsSummariesForCurrentUser', [createdInLastXDays]);
        },
        getPoliciesInForceByAccount: (account) => {
            return JsonRPCService.send('bc', 'gatewaycommission/commission', 'getPoliciesInForceByAccount', [account]);
        },
        getCommissionsTransactionsByAccount: (account) => {
            return JsonRPCService.send('bc', 'gatewaycommission/commission', 'getCommissionsTransactionsByAccount', [account]);
        },
        accountExists: (account) => {
            return JsonRPCService.send('bc', 'gatewayaccount/account', 'accountExists', [account]);
        }
    };
}];